import { APP_INITIALIZER, ErrorHandler, enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, Router, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { provideServiceWorker } from '@angular/service-worker';
import { HttpClientModule } from '@angular/common/http';

import { addIcons } from 'ionicons'
import { briefcaseOutline, searchCircleOutline, pencil, cloudDownloadOutline,reloadOutline, checkbox, cloudUploadOutline, chevronForward, calendar, personCircleSharp, trashOutline, home, eye, eyeOffSharp, reader, layers, close, trash, 
  caretForward, checkmarkDoneOutline, checkmarkCircle, refreshOutline, camera, arrowUndo, save, add, duplicate, warningSharp, personCircleOutline, homeOutline, layersOutline, 
  readerOutline, personOutline, logOutOutline, warning, locate, arrowDown, sync, cameraOutline, addCircleOutline, phonePortraitOutline, fileTrayFullOutline, closeOutline,
  documentTextOutline, settingsOutline, medalOutline, navigateOutline, mailOutline, refreshCircleOutline, documentLockOutline, downloadOutline, cloudOfflineOutline, hourglassOutline, 
  callOutline, backspaceOutline, documentOutline, checkmarkOutline, checkmarkCircleSharp, informationCircleOutline, informationCircle, informationOutline,
  arrowForwardOutline, arrowDownCircle, arrowUpCircle, grid, chevronBackOutline, folderOpenOutline, folderOutline, alertCircle,
  chevronForwardOutline, list, serverOutline, keypadOutline, barcodeOutline, qrCodeOutline, lockClosedOutline, lockOpenOutline} from 'ionicons/icons'

import * as Sentry from '@sentry/angular-ivy'
import { Capacitor } from '@capacitor/core';

/*Sentry.init({
  dsn: "https://8d4ae55e5b1f2e1e85486830d6113c59@sentry.fontventa.com/59",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/ingeinerp\.fontventa\.com\/api/],
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})*/

if (environment.production) {
  enableProdMode();
}

addIcons({ briefcaseOutline, searchCircleOutline, pencil, cloudDownloadOutline,reloadOutline, checkbox, cloudUploadOutline, chevronForward,trashOutline, calendar, personCircleSharp, home, eye, eyeOffSharp, reader, layers, close, trash, 
  caretForward, checkmarkDoneOutline, checkmarkCircle, refreshOutline, camera, arrowUndo, save, add, duplicate, warningSharp, personCircleOutline, homeOutline, layersOutline,
  readerOutline, personOutline, logOutOutline, warning, locate, arrowDown, sync, cameraOutline, addCircleOutline, phonePortraitOutline, fileTrayFullOutline, closeOutline,
  documentTextOutline, settingsOutline, medalOutline, navigateOutline ,refreshCircleOutline,  documentLockOutline,mailOutline, downloadOutline, cloudOfflineOutline, hourglassOutline, 
  callOutline, backspaceOutline, documentOutline, checkmarkOutline, checkmarkCircleSharp, informationCircleOutline, informationCircle, informationOutline, arrowForwardOutline, arrowDownCircle, arrowUpCircle,
  chevronBackOutline, chevronForwardOutline, list, grid, folderOpenOutline, folderOutline, serverOutline, keypadOutline, barcodeOutline, qrCodeOutline, alertCircle,
  lockClosedOutline, lockOpenOutline
})

let extraProviders = []
if (!Capacitor.isNativePlatform()) {
  if (location.hostname !== 'localhost') {
    extraProviders.push(
      provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
      })
    )
  }
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    importProvidersFrom(HttpClientModule),
    provideIonicAngular({
      innerHTMLTemplatesEnabled: true
    }),
    provideRouter(routes),
    ...extraProviders
    /*{
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },*/
  ],
});
